import { useMemo } from 'react'
import { Empty } from 'antd'
import PageWrapper from '@/components/page-wrapper'
import FeatureBanner from '@/components/feature-banner'
import List from './list'
import Styles from './style.module.scss'
import useLang from '@/utils/hooks/use-lang'
import CustomTabs from './tab'
import { useHashQueryParam } from '@/utils/hooks/use-tab-from-hash'
import ImageInsightBanner from '@/assets/img/insight/insight-banner.jpg'
import ImageEmpty from '@/assets/img/empty-list.png'

const title_text = {
  en: 'News & blog',
  es: 'Noticias',
  cn: '新闻中心',
}

const TABS = [
  { key: 'all', label: 'All' },
  { key: 'government', label: 'Government Policies & Regulations' },
  { key: 'carbon', label: 'Carbon Neutrality & Emissions Reduction' },
  { key: 'clean', label: 'Clean Energy Initiatives' },
]
const TAB_KEYS = TABS.map(t => t.key)

const DEFAULT_TAB = 'all'

const EMPTY_DESCRIPTION = 'No news at the moment'

export default function Index() {
  const [lang] = useLang()
  const [getTab, setTab] = useHashQueryParam('tab', DEFAULT_TAB)

  const activeTab = useMemo(() => {
    const key = getTab()
    return TAB_KEYS.includes(key) ? key : DEFAULT_TAB // 防止非法值
  }, [getTab])

  return (
    <PageWrapper>
      <FeatureBanner title={title_text[lang]} description='' backgroundImage={ImageInsightBanner} />
      <CustomTabs value={activeTab} onChange={setTab} items={TABS} />
      {activeTab === 'all' ? (
        <div className={Styles.listContainer}>
          <List />
        </div>
      ) : (
        <div className={Styles.emptyContainer}>
          <Empty image={ImageEmpty} description={EMPTY_DESCRIPTION} />
        </div>
      )}
    </PageWrapper>
  )
}
